import { articleDetail, getHomeData } from "@/api/home.js";
const state = {};
const getters = {};
const mutations = {};
const actions = {
  // 获取文章详情
  // eslint-disable-next-line no-unused-vars
  getDetail: ({ state, commit, dispatch }, form) => {
    return new Promise((resolve) => {
      articleDetail({ id: form.id }).then((ele) => {
        resolve(ele);
      });
    });
  },
  // 获取文章
  getHomeList: (state, form) => {
    return new Promise((resolve) => {
      let params = {
        pageSize: form.pageSize || 10,
        pageNum: form.pageNum || 1,
      };
      getHomeData(params, { code: form.code, moduleId: form.id, picture: form.picture, summary: form.summary }).then(
        (res) => {
          resolve(res);
        }
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
